import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import ProductLineTable from "../../../components/Product/product-line"

const ProductLine = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Service Line | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <ProductLineTable />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default ProductLine
